export default {"src":"/_next/static/media/subjectNew.cf53b04e.svg","height":97,"width":89,"blurWidth":0,"blurHeight":0};